export const activityInfo = "/v3/user/activity/page"  // 活动信息
export const inviteInfo = "/v3/user/activity/invitation/msg"  // 邀请信息
export const invitedPage = "http://ryere.cn/activity/may/#/invited" // 邀请页面
export const userPageStatus = "/v3/user/activity/user/pageStatus" // 获取用户页面状态
export const getSMSCode = '/v3/user/getsmscode'; // 获取验证码
export const getLogin = "/v3/user/rescues/register" // 注册

export const getOrganization = '/v3/user/channel/organization/list' //查询渠道机构列表

// export const userServiceAgreement = "/rescue_eye_mobile/#/service-agreement"  // 服务协议
export const userServiceAgreement = "/protocol/#/userProtocol"// 新服务协议

// export const userPrivacyAgreement = "/rescue_eye_mobile/#/privacy-policy";  // 隐私协议
export const userPrivacyAgreement = "/protocol/#/privacyPolicy";  // 新隐私协议

export const activityLocation = "/v3/user/activity/location?eventId=7"; // 喀什马拉松地址
export const activityUser = '/v3/user/activity/location/users?eventId=7';
export const userInfo = "/v3/rescue/event/user/info" // 获取用户信息
export const modifyUserInfo = "/v3/rescue/event/user/info" // 修改昵称
export const userPrize = "/v3/user/activity/user/prize" // 查看抽奖结果

export const uploadImage = '/v3/content/temp/sign' //获取文件签名
export const submitCert = '/v3/user/submit/cert' //提交资质认证信息'
/* 废弃接口 */
// export const getDrawCode = "/v1/emergency/eye/draw/code" // 获取抽奖码
// export const drawLottery = "/v2/user/raffleKill"  // 抽奖
// export const chanceInfo = "/v1/emergency/eye/get/roll/invitation" // 获取抽奖机会



// WEBPACK FOOTER //
// ./src/common/constant.js